export const GroupEmailSaveHeights = () => {
    const GroupMembersUL = document.getElementById('GroupMembers') as HTMLUListElement;
    const GroupMemberEmailsTextArea = document.getElementById('GroupMemberEmails') as HTMLTextAreaElement;

    localStorage.setItem("TrainingGroupMembersHeight", GroupMembersUL.style.height);
    localStorage.setItem("TrainingGroupMembersEmailsHeight", GroupMemberEmailsTextArea.style.height);
}

